module.exports = __webpack_public_path__ + "img/c4.92b32908.png";